/**
 * Creates a memory storage instance that can be used in environments without access to localStorage and sessionStorage.
 */
export const createMemoryStorage = () => {
    let memoryStorageObject = {};
    return {
        get length() {
            return Object.keys(memoryStorageObject).length;
        },
        clear: () => {
            memoryStorageObject = {};
        },
        getItem: (key) => {
            return memoryStorageObject[key] || null;
        },
        key: (index) => {
            return Object.keys(memoryStorageObject)[index] || null;
        },
        removeItem: (key) => {
            delete memoryStorageObject[key];
        },
        setItem: (key, value) => {
            memoryStorageObject[key] = value;
        }
    };
};
//# sourceMappingURL=create-memory-storage.js.map